import { useEffect, useRef } from 'react';
import { DEFAULT_CONFIG } from '@qapline/config';

export function useDocumentTitle(title: string, prevailOnUnmount = true) {
    const defaultTitle = useRef(DEFAULT_CONFIG.app.base_title);

    useEffect(() => {
        document.title = `${title} | ${defaultTitle.current}`;
    }, [title]);

    useEffect(() => () => {
        if (!prevailOnUnmount) {
            document.title = defaultTitle.current;
        }
    });
}
